// eslint-disable-next-line @typescript-eslint/no-restricted-types -- API schemas explicitly distinguish JSON null from omitted fields.
type NullValue = null;

export type ProductQtyDefault = {
  product: string;
  accountId?: string | NullValue;
  isAcctSetByUser: boolean;
  qty?: number | NullValue;
  isQtySetByUser: boolean;
  isIceberg?: boolean;
  icebergDisplayQty?: number;
};

export type TradableSymbol = {
  segmentMic: string;
  rootSymbol?: string | NullValue;
  symbolName?: string | NullValue;
  defaultAccount?: string | NullValue;
  defaultQty?: number | NullValue;
  acctSetByUser?: boolean | NullValue;
  qtySetByUser?: boolean | NullValue;
  isIceberg?: boolean | NullValue;
  icebergDisplayQty?: number | NullValue;
};

export type DefaultDbResult = {
  id: number;
  userId: string;
  symbol: string;
  accountId?: string;
  isAcctSetByUser: number;
  qty?: number;
  isQtySetByUser: number;
  isIceberg?: number;
  icebergDisplayQty?: number;
};

export type DefaultUpdateResponse = {
  fieldCount?: number | NullValue;
  affectedRows?: number | NullValue;
  products: TradableSymbol[];
};
